import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import Learning from '../../../../assets/images/learning.svg';
import Tower from '../../../../assets/images/tower.svg';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';

interface SectionEightProps {
  section: OnboardingSummary;
}

const SectionEight = ({ section }: SectionEightProps) => {
  const { topicsExploring, learningStyle } = useOnboardingSummary({
    section,
  });

  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>
        General learning and professional development
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Tower} alt='Tower' />{' '}
            Topics you're exploring:
          </div>
          <div className='text-lg'>{topicsExploring}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={Learning}
              alt='Learning'
            />{' '}
            Learning style:
          </div>
          <div className='text-lg'>{learningStyle}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionEight;
